import { render, staticRenderFns } from "./vehicle-details.vue?vue&type=template&id=af51b39c"
import script from "./vehicle-details.vue?vue&type=script&lang=js"
export * from "./vehicle-details.vue?vue&type=script&lang=js"
import style0 from "./vehicle-details.vue?vue&type=style&index=0&id=af51b39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports